import React, { useEffect } from 'react'
import { IPalette } from 'containers/dashboard/design/color-palette/store/types'
import './NewLoaderContent.css'

interface NewLoaderContentProps {
    palette?: IPalette
    children: React.ReactNode
}

const NewLoaderContent: React.FC<NewLoaderContentProps> = ({
    palette,
    children,
}) => {
    const contentStyle = {
        color: palette?.text || '#c8c8c8',
    }

    useEffect(() => {
        const root = document.documentElement
        if (palette) {
            root.style.setProperty(
                '--background-color',
                palette.background || '#fafafa',
            )
            root.style.setProperty(
                '--contrast-color',
                palette.primaryContrast || '#f2f2f2',
            )
            root.style.setProperty(
                '--primary-color',
                palette.primary || '#9d9e9e',
            )
            root.style.setProperty(
                '--surface-color',
                palette.surface || '#f2f2f2',
            )
            root.style.setProperty('--text-color', palette.text || '#55554')
            root.style.setProperty(
                '--navbar-color',
                palette.navBar || '#fafafa',
            )
            root.style.setProperty(
                '--tabbar-color',
                palette.tabBar || '#fafafa',
            )
        }
    }, [palette])

    return (
        <div className='new-loader-content' style={contentStyle}>
            {children}
        </div>
    )
}

export default NewLoaderContent
